import { gql } from '@apollo/client';
import { useFlag } from '@modernloop/shared/feature-flag';

import { useBrighthireIntegrationsQueryQuery } from 'src/generated/mloop-graphql';

import { useOrgAtsService } from 'src/hooks/atsService';

export const useIsBrighthireIntegrationEnabled = () => {
  const brighthireFeatureFlagEnabled = useFlag('prd-249-brighthire-integration');
  const { data: integrationsData } = useBrighthireIntegrationsQueryQuery({
    skip: !brighthireFeatureFlagEnabled,
  });

  const atsService = useOrgAtsService();

  return Boolean(
    brighthireFeatureFlagEnabled &&
    integrationsData?.thisOrg?.integrations?.brighthire?.apiKey &&
    atsService?.canSupportBrightHire
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BRIGHTHIRE_INTEGRATIONS_QUERY = gql`
  query BrighthireIntegrationsQuery {
    thisOrg {
      integrations {
        id
        brighthire {
          apiKey
        }
      }
    }
  }
`;
